import { ExperienceInterface } from "../../models/resume/experienceInterface";

/* @Todo Add your work experience below.
   - Add your company logo to the public/images/logos folder and link to them in the imageURL.
   - Remove sections by deleting content within (and including) the curly braces.
   - Add a section by copying and pasting the template into the specified section below. Update the id.
   ---------- Template Start -----------
{
        id: '0', // update the id
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos,
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt.
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt.
                 Ut veri melius oporteat sed.`,
                `ADD MORE RESPONSIBILITIES BY ADDING A COMMA TO THE LAST ITEM IN THIS LIST. PUT THE TEXT BETWEEN BACK
                TICKS`
            ],
    },
       ---------- Template End -----------
* */


export const experiences: ExperienceInterface[] =
    [{
        id: '0',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    {
        id: '1',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    {
        id: '2',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    {
        id: '3',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    {
        id: '4',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    {
        id: '5',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    {
        id: '6',
        company: 'Company Name',
        title: 'Title',
        companyURL: 'URL to company here',
        imageURL: '/images/logos/default.png',
        location: 'City, State',
        startDate: 'Month YYYY',
        endDate: 'Month YYYY',
        keyAccomplishment: `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos, 
        est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
        Ut veri melius oporteat sed.`,
        otherResponsibilities:
            [
                `Lorem ipsum dolor sit amet, iriure fabellas expetendis sed ad, in modo summo mazim eos.`,
                `est sonet detraxit mediocritatem te. Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. 
                 Ut veri melius oporteat sed.`,
                `Ius tantas admodum tincidunt ut, te pro melius maluisset tincidunt. Ut veri melius oporteat sed. 
                Legere persius mentitum eu sed, est at veniam molestiae.`
            ],
    },
    // Add another experience here from the template above.
]